import { useEffect, useState } from "react";
import { showToastError } from "../../../services/toast";

interface SelectProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  fetchOptions:
    | { label: string; value: string; idTemplate?: number }[]
    | (() => Promise<{ label: string; value: string; idTemplate?: number }[]>);
  className?: string;
  disabled?: boolean;
  required?: boolean;
}

export function Select({
  label,
  name,
  value,
  onChange,
  fetchOptions,
  className: clasName,
  disabled,
  required,
}: SelectProps) {
  const [options, setOptions] = useState<
    { label: string; value: string; idTemplate?: number }[]
  >([]);

  useEffect(() => {
    if (Array.isArray(fetchOptions)) {
      setOptions(fetchOptions);
    } else if (typeof fetchOptions === "function") {
      fetchOptions().then(setOptions).catch((err) => {
        showToastError(err.response.data.message)
      });
    }
  }, [fetchOptions]);

  return (
    <div className={`flex flex-col text-grey ${clasName}`}>
      <label className="3xl:text-md text-sm font-thin">
        {label} {label === "" ? "" : ":"}
      </label>
      <select
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={`bg-white shadow-lg border-light-blue border-2 rounded-md 3xl:p-2 p-1 mt-1 ${clasName} `}
      >
        <option value="">Sélectionnez une option</option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            data-id-template={option.idTemplate}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
